import React, { PropsWithChildren } from 'react';
import { css } from '@emotion/react';
import styled from '@emotion/styled';
import Button from '@mui/material/Button';

import {
  darkGrey,
  sizeMobile,
  turquoise,
  playlistHeight,
  expandedPlaylistHeight,
  leftPanelZIndex,
} from '~/styles';

import { LocalizedLink } from '../../LocalizedLink';

export const DropDownMenuContainer = styled.div<{
  isLoggedIn?: boolean;
  playlistEnabled?: boolean;
  playlistDetailView?: boolean;
  hideUserMenu?: boolean;
}>`
  ${props =>
    props.playlistEnabled
      ? props.playlistDetailView
        ? css`
            height: calc(100% - (${expandedPlaylistHeight} + var(--Header-Height)));
          `
        : css`
            height: calc(100% - (${playlistHeight} + var(--Header-Height)));
          `
      : css`
          height: calc(100% - var(--Header-Height));
        `};
  width: 376px;
  border-radius: 0 0 16px 16px;
  box-shadow: 0 2px 16px 0 rgba(0, 0, 0, 0.5);
  background-color: ${darkGrey};
  padding: 60px 0 16px;
  z-index: ${leftPanelZIndex};
  position: fixed;
  right: 0;
  top: var(--Header-Height);
  text-align: left;
  -webkit-transition: 0.5s;
  -moz-transition: 0.5s;
  -o-transition: 0.5s;
  transition: 0.5s;
  visibility: visible;
  opacity: 1;
  scrollbar-color: ${darkGrey} ${darkGrey};
  scrollbar-width: none;
  &::-webkit-scrollbar {
    width: 0px;
  }
  &::-webkit-scrollbar-thumb {
    background: ${darkGrey};
  }
  ${props =>
    props.isLoggedIn &&
    css`
      bottom: 0;
      overflow-y: scroll;
    `};

  ${props =>
    props.hideUserMenu &&
    css`
      visibility: hidden;
      opacity: 0;
    `}
  ${sizeMobile(css`
    width: 100%;
  `)};
`;

const LinkStyles = css`
  cursor: pointer;
  cursor: pointer;
  display: block;
  text-decoration: none;
  vertical-align: middle;
  &:hover {
    background: ${turquoise};
    text-decoration: none;
  }
`;

const BaseLocalizedLink: React.FC<React.ComponentProps<typeof LocalizedLink>> = ({ ...props }) => (
  <LocalizedLink {...props} />
);
export const MenuLink = styled(BaseLocalizedLink)`
  ${LinkStyles};
`;

export const MenuExternalLink = styled.a`
  ${LinkStyles};
`;

type MenuItemsProps = { centered?: boolean };
const BaseButton: React.FC<React.ComponentProps<typeof Button>> = props => <Button {...props} />;
export const MenuItem = styled(BaseButton)<MenuItemsProps>`
  width: 100%;
  padding: 12px 12px;
  color: white;
  font-size: 15.8px;
  text-align: left;
  text-transform: capitalize;
  justify-content: ${props => (props?.centered ? 'center' : 'flex-start')};

  ${sizeMobile(css`
    font-size: 12px;
  `)};

  .MuiSvgIcon-root {
    margin-right: 16px;
    ${sizeMobile(css`
      margin-right: 8px;
    `)};
  }
` as React.FC<PropsWithChildren<MenuItemsProps & React.ComponentProps<typeof Button>>>;
